(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__hbQuickAddBound) return;
    window.__hbQuickAddBound = true;

    document.addEventListener('click', async function (event) {
      var btn = event.target.closest('[data-hb-quick-add]');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      if (btn.disabled) return;

      var label = btn.querySelector('.hb-quick-add__label');
      btn.classList.add('is-loading');

      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });
      var formData = new FormData();
      formData.append('id', btn.dataset.variantId);
      formData.append('quantity', '1');
      if (sectionIds.length) formData.append('sections', sectionIds.join(','));

      var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
      try {
        var res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: formData
        });
        var data = await res.json();
        if (data.status) throw new Error(data.description || data.message);

        var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
        var cartEvent = new Event('cart:update', { bubbles: true });
        cartEvent.detail = {
          resource: cart,
          sourceId: btn.dataset.variantId,
          data: { source: 'hb-quick-add', itemCount: 1, productId: btn.dataset.productId, variantId: btn.dataset.variantId, sections: data.sections }
        };
        btn.dispatchEvent(cartEvent);

        if (label) {
          label.textContent = label.dataset.added;
          setTimeout(function () { label.textContent = label.dataset.default; }, 2000);
        }
      } catch (error) {
        console.error('[hb-quick-add]', error);
      } finally {
        btn.classList.remove('is-loading');
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["discount-code-copy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('discount-code-copy')) {
    class DiscountCodeCopy extends HTMLElement {
      connectedCallback() {
        this.handle = this.handle.bind(this);
        this.addEventListener('click', this.handle);
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handle();
          }
        });
      }

      async handle() {
        const code = this.dataset.code;
        if (!code) return;

        let copied = false;
        try {
          await navigator.clipboard.writeText(code);
          copied = true;
        } catch (e) {
          const ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0;';
          document.body.appendChild(ta);
          ta.select();
          try { copied = document.execCommand('copy'); } catch (err) {}
          ta.remove();
        }

        if (this.dataset.autoApply === 'true' && !this.applied) {
          this.applied = true;
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(() => {});
        }

        this.showFeedback(copied);
      }

      showFeedback(copied) {
        const labels = this.querySelectorAll('.dcc__feedback');
        const live = this.querySelector('.dcc__live');

        clearTimeout(this.timer);
        this.classList.add('is-copied');
        labels.forEach((el) => {
          el.textContent = copied ? el.dataset.copied : this.dataset.code;
        });
        if (live) live.textContent = copied ? labels[0]?.dataset.copied || '' : '';

        this.timer = setTimeout(() => {
          this.classList.remove('is-copied');
          labels.forEach((el) => {
            el.textContent = el.dataset.default;
          });
          if (live) live.textContent = '';
        }, parseInt(this.dataset.copiedDuration, 10) || 2500);
      }
    }
    customElements.define('discount-code-copy', DiscountCodeCopy);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hb-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__hbUpsellBound) return;
    window.__hbUpsellBound = true;

    document.addEventListener('click', async function (event) {
      var btn = event.target.closest('[data-hb-upsell-add]');
      if (!btn || btn.disabled) return;
      event.preventDefault();

      btn.classList.add('is-loading');
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });

      var formData = new FormData();
      formData.append('id', btn.dataset.variantId);
      formData.append('quantity', '1');
      if (sectionIds.length) formData.append('sections', sectionIds.join(','));

      var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
      try {
        var res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: formData
        });
        var data = await res.json();
        if (data.status) throw new Error(data.description || data.message);

        var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
        var cartEvent = new Event('cart:update', { bubbles: true });
        cartEvent.detail = {
          resource: cart,
          sourceId: btn.dataset.variantId,
          data: {
            source: 'hb-upsell',
            itemCount: 1,
            productId: btn.dataset.productId,
            variantId: btn.dataset.variantId,
            sections: data.sections
          }
        };
        btn.dispatchEvent(cartEvent);

        btn.textContent = btn.dataset.added;
        setTimeout(function () { btn.textContent = btn.dataset.label; }, 2500);
      } catch (error) {
        console.error('[hb-upsell]', error);
        btn.textContent = btn.dataset.label;
      } finally {
        btn.classList.remove('is-loading');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('review-carousel')) {
    class ReviewCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.review-carousel__track');
        this.dotsEl = this.querySelector('.review-carousel__dots');
        this.index = 0;
        this.paused = false;
        this.refresh();

        // Sub-blokken toevoegen/verwijderen in de theme editor
        this.observer = new MutationObserver(() => this.refresh());
        this.observer.observe(this.track, { childList: true });

        if (this.dataset.pauseOnHover === 'true') {
          this.addEventListener('mouseenter', () => this.pause());
          this.addEventListener('mouseleave', () => this.resume());
        }
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.resume());

        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        // Swipen op mobiel
        this.track.addEventListener('pointerdown', (e) => {
          this.startX = e.clientX;
        });
        this.track.addEventListener('pointerup', (e) => {
          if (this.startX == null) return;
          const dx = e.clientX - this.startX;
          this.startX = null;
          if (Math.abs(dx) > 40) {
            this.go(this.index + (dx < 0 ? 1 : -1));
            this.start();
          }
        });

        // Theme editor: geselecteerde review tonen
        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target.closest('.review-carousel__slide'));
          if (i === -1) return;
          this.editorSelected = true;
          this.stop();
          this.go(i);
        };
        this.onBlockDeselect = (e) => {
          if (this.slides.indexOf(e.target.closest('.review-carousel__slide')) === -1) return;
          this.editorSelected = false;
          this.start();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      refresh() {
        this.slides = Array.from(this.track.querySelectorAll(':scope > .review-carousel__slide'));
        if (this.index >= this.slides.length) this.index = 0;
        this.buildDots();
        this.go(this.index);
        this.start();
      }

      buildDots() {
        this.dotsEl.innerHTML = '';
        const show = this.dataset.showDots === 'true' && this.slides.length > 1;
        this.dotsEl.hidden = !show;
        if (!show) return;
        this.slides.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'review-carousel__dot';
          dot.setAttribute('aria-label', `Review ${i + 1}`);
          dot.addEventListener('click', () => {
            this.go(i);
            this.start();
          });
          this.dotsEl.appendChild(dot);
        });
      }

      go(i) {
        const n = this.slides.length;
        if (!n) return;
        this.index = ((i % n) + n) % n;
        this.slides.forEach((slide, j) => {
          const active = j === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        Array.from(this.dotsEl.children).forEach((dot, j) => {
          dot.setAttribute('aria-current', j === this.index ? 'true' : 'false');
        });
      }

      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.paused || this.editorSelected) return;
        if (this.slides.length < 2 || document.hidden) return;
        const interval = parseInt(this.dataset.interval, 10) || 5000;
        this.timer = setInterval(() => this.go(this.index + 1), interval);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      pause() {
        this.paused = true;
        this.stop();
      }

      resume() {
        this.paused = false;
        this.start();
      }
    }
    customElements.define('review-carousel', ReviewCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
